<template>
  <div class="home">
		<SineFunction :args=args />
		<Placeholders :args=args @updating="onUpdate" />
		<div class="canvas-wrapper">
		<CanvasThree :width=width :height=height :args=args :canvasId=canvasId[0] :canvasType=canvasType[0] />
		<CanvasThree :width=width :height=height   :args=args :canvasId=canvasId[1] :canvasType=canvasType[1] />
		<CanvasThree :width=width :height=height   :args=args :canvasId=canvasId[2] :canvasType=canvasType[2] />
		</div>
  </div>
	<div class="empty" v-show="empty">
	</div>
	<footer>
		by <a href="https://www.lorismat.com" target=_blank>Loris Mat</a>
	</footer>
</template>

<script>
// @ is an alias to /src
import SineFunction from '@/components/SineFunction.vue'
import Placeholders from '@/components/Placeholders.vue'
import CanvasThree  from '@/components/CanvasThree.vue'

export default {
  name: 'Home',
  components: {
		SineFunction,
		Placeholders,
		CanvasThree
  },
	data() {
		return {
			args: {amplitude:3,frequency: 2, phase:1},
			canvasId: ["c1","c2", "c3"],
			canvasType: ["movement", "camera", "light"],
			width: 400,
			height: 400,
		}
	},
	methods: {
		onUpdate(value) {
			this.args[value.id] = value.val;
		},
	},
	created() {
	},
	computed: {
		empty() {
			if (window.innerWidth > 1000) {
				return true
			}
		}
	}
}
</script>

<style scoped>

.home {
	color: var(--col1);
}

.canvas-wrapper {
	display: flex;
	justify-content: center;
}

@media only screen and (max-width: 700px) {
	.canvas-wrapper {
		flex-direction: column;
	}
}

footer, footer > a{
	color: var(--grey); 
}

footer > a:hover {
	color: var(--grey);
	text-decoration: none;
}

</style>
